import script from "./Topbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Topbar.vue?vue&type=script&setup=true&lang=js"

import "./Topbar.vue?vue&type=style&index=0&id=9d052882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d052882"]])

export default __exports__